import React from "react";
import SEO from "../components/SEO";
import { businessInfo } from "../data/content";

export default function Legal() {
  return (
    <>
      <SEO
        title="Mentions légales | Pereira Plomberie Chauffage"
        description="Mentions légales du site Pereira Plomberie Chauffage, artisan plombier chauffagiste à Meaux (77)."
      />

      <section className="bg-primary text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-heading text-3xl md:text-4xl font-bold uppercase tracking-tight" data-testid="legal-title">
            Mentions légales
          </h1>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate prose-sm">
          <h2 className="font-heading text-xl font-bold uppercase tracking-tight">Éditeur du site</h2>
          <p>
            <strong>{businessInfo.name}</strong><br />
            {businessInfo.address.full}<br />
            Téléphone : <a href={businessInfo.phoneTel}>{businessInfo.phone}</a><br />
            Email : <a href={businessInfo.emailLink}>{businessInfo.email}</a>
          </p>
          <p>
            <strong>SIRET :</strong> [NUMERO_SIRET]<br />
            <strong>Forme juridique :</strong> [FORME_JURIDIQUE]<br />
            <strong>Responsable de la publication :</strong> {businessInfo.publisher}
          </p>

          <h2 className="font-heading text-xl font-bold uppercase tracking-tight mt-8">Hébergement</h2>
          <p>
            <strong>{businessInfo.hosting.name}</strong><br />
            {businessInfo.hosting.address}<br />
            Site : <a href={businessInfo.hosting.website} target="_blank" rel="noopener noreferrer">{businessInfo.hosting.label}</a>
          </p>

          <h2 className="font-heading text-xl font-bold uppercase tracking-tight mt-8">Conception et réalisation</h2>
          <p>
            Site créé par <a href={businessInfo.hosting.website} target="_blank" rel="noopener noreferrer">{businessInfo.hosting.name}</a>.
          </p>

          <h2 className="font-heading text-xl font-bold uppercase tracking-tight mt-8">Propriété intellectuelle</h2>
          <p>L'ensemble du contenu de ce site (textes, images, logos) est la propriété exclusive de {businessInfo.name}, sauf mention contraire. Toute reproduction, même partielle, est interdite sans autorisation préalable.</p>

          <h2 className="font-heading text-xl font-bold uppercase tracking-tight mt-8">Données personnelles</h2>
          <p>Les informations recueillies via le formulaire de contact sont destinées exclusivement à {businessInfo.name} pour le traitement de votre demande. Conformément au RGPD, vous disposez d'un droit d'accès, de modification et de suppression de vos données personnelles.</p>
        </div>
      </section>
    </>
  );
}
